/**
 * Per-field error messages on the checkout.
 *
 * WooCommerce marks invalid fields with `.woocommerce-invalid` on the enclosing
 * `.form-row`, including after a failed submit -- checkout.js re-validates every
 * field in submit_error():
 *
 *   $checkout_form.find('.input-text, select, input:checkbox')
 *     .trigger('validate').trigger('blur');
 *
 * What it does NOT do is put a message next to the offending field; it only
 * renders the notice list above the form. This adds the message, so an invalid
 * field reads the same way the Stripe card fields already do: red border on the
 * control, red line of text underneath.
 *
 * Styling lives in scss/woocommerce/checkout/woocommerce-checkout-general.scss.
 */
(function ($) {
  var MESSAGE_CLASS = 'brunetti-field-error';

  // Label text without the required marker, e.g. "Billing Phone *" -> "Billing Phone".
  function labelFor($row) {
    var $label = $row.find('label').first();
    if (!$label.length) {
      return '';
    }

    return $.trim($label.clone().find('.required, .optional').remove().end().text());
  }

  // Mirrors WooCommerce's own notice wording so the message beside the field and
  // the message in the list above the form say the same thing.
  function messageFor($row) {
    var label = labelFor($row);

    if ($row.hasClass('woocommerce-invalid-required-field')) {
      return label ? label + ' is a required field.' : 'This is a required field.';
    }

    if ($row.hasClass('woocommerce-invalid-email')) {
      return 'Please enter a valid email address.';
    }

    return label ? 'Please check ' + label + '.' : 'Please check this field.';
  }

  // The message goes after the input wrapper so it sits under the control
  // rather than between the label and the field.
  function targetContainer($row) {
    var $wrapper = $row.find('.woocommerce-input-wrapper').first();
    return $wrapper.length ? $wrapper : $row;
  }

  function syncRow() {
    var $row = $(this);
    var $existing = $row.find('.' + MESSAGE_CLASS);

    if (!$row.hasClass('woocommerce-invalid')) {
      $existing.remove();
      return;
    }

    var text = messageFor($row);

    if ($existing.length) {
      if ($existing.text() !== text) {
        $existing.text(text);
      }
      return;
    }

    $('<span>', { 'class': MESSAGE_CLASS, text: text }).appendTo(targetContainer($row));
  }

  function sync() {
    var $form = $('form.checkout');
    if (!$form.length) {
      return;
    }
    $form.find('.form-row').each(syncRow);
  }

  $(function () {
    if (!$('body').hasClass('woocommerce-checkout')) {
      return;
    }

    // After a failed submit. WooCommerce has already re-validated every field by
    // the time this fires, so the classes are in place.
    $(document.body).on('checkout_error', sync);

    // WooCommerce validates a field on blur/change; re-sync just after so the
    // message clears as soon as the customer fixes it. The timeout lets
    // WooCommerce's own handler set the classes first.
    $(document).on('blur change', 'form.checkout input, form.checkout select, form.checkout textarea', function () {
      window.setTimeout(sync, 0);
    });

    // The form can be re-rendered by a fulfilment or address change.
    $(document.body).on('updated_checkout', sync);
  });
})(jQuery);
